import { useState } from "react";
import { BsQrCode } from "react-icons/bs";
import { toast } from "react-toastify";
import { copyUrlAsLink } from "@/utils/copyUrlAsLink";
import QrModal from "./QrModal";

type ReusableCodeResultProps = {
  code: string;
  onClose: () => void;
};

export default function ReusableCodeResult({ code, onClose }: ReusableCodeResultProps) {
  const [qrOpen, setQrOpen] = useState(false);
  const url = `${import.meta.env.VITE_TEST_RUNNER_URL}${code}`;

  async function copyLink() {
    try {
      const copied = await copyUrlAsLink(url);
      if (copied) toast.success(`Copied URL to clipboard: ${url}`);
      else toast.error("Could not copy URL to clipboard");
    } catch (err) {
      console.error("Clipboard error:", err);
      toast.error("Could not copy URL to clipboard");
    }
  }

  return (
    <div className="reusableCodeResult">
      <p>Give this link to each candidate. Each person who opens it starts their own questionnaire.</p>
      <div className="tableWrapper factTable">
        <table>
          <tbody>
            <tr>
              <th>Code</th>
              <td className="reusableCodeValue">
                <a onClick={copyLink} title="Copy questionnaire URL">{code}</a>
                <BsQrCode
                  className="actionIcon qrCode"
                  title="View QR code"
                  onClick={() => setQrOpen(true)}
                />
              </td>
            </tr>
            <tr>
              <th>Link</th>
              <td>
                <a onClick={copyLink} title="Copy questionnaire URL">{url}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="reusableCodeActions">
        <button type="button" className="btn primaryButton" onClick={onClose}>Close</button>
      </div>
      <QrModal isOpen={qrOpen} onClose={() => setQrOpen(false)} content={url} />
    </div>
  );
}
